import { render, staticRenderFns } from "./BalanceHeader.vue?vue&type=template&id=3e81c930&"
import script from "./BalanceHeader.vue?vue&type=script&lang=ts&"
export * from "./BalanceHeader.vue?vue&type=script&lang=ts&"
import style0 from "./BalanceHeader.vue?vue&type=style&index=0&id=3e81c930&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports